module.exports = __webpack_public_path__ + "assets/ruby-on-rails.dcef4ae3.svg";